export default "__VITE_ASSET__BJugRMOt__"